import type { ACCEPT_DOC_FILES } from '../constants';

export function createFileFormatValidator(validFileFormats: string[]) {
  return (file: File) =>
    new Promise<File | void>((resolve, reject) => {
      if (!file) {
        resolve();
      }
      const fileFormat = file.name.replace(/^.*\./, '.').toLowerCase();
      if (validFileFormats.includes(fileFormat)) {
        resolve(file);
      } else {
        reject({ code: 'error.fileformat' });
      }
    });
}

export function createFileNameLengthValidator(maxLength: any) {
  return (value: any) =>
    new Promise<void>((resolve, reject) => {
      if (!value) {
        resolve();
      }
      if (value.name.length <= maxLength) {
        resolve(value);
      } else {
        reject({ code: 'too_long' });
      }
    });
}

export function createFileSizeValidator(maxFileSize: number) {
  return (value: any) =>
    new Promise<void>((resolve, reject) => {
      if (!value) {
        resolve();
      }
      if (value.size <= maxFileSize) {
        resolve(value);
      } else {
        reject({ code: 'document_too_large' });
      }
    });
}

export type ValidatorProps = {
  validFileFormats?: typeof ACCEPT_DOC_FILES;
  maxFilenameLength?: number;
  maxFileSize?: number;
};

export const createFileValidators = ({
  validFileFormats,
  maxFilenameLength,
  maxFileSize,
}: ValidatorProps) => {
  const validators: any[] = [];
  if (validFileFormats) validators.push(createFileFormatValidator(validFileFormats));
  if (maxFilenameLength) validators.push(createFileNameLengthValidator(maxFilenameLength));
  if (maxFileSize) validators.push(createFileSizeValidator(maxFileSize));

  return validators;
};
